import { AlulaResponseData } from "@app/shared/databases/alula.database";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface AlulaReceiver {
    id?: string;
    dealerId: string;
    receiverType: string;
    name: string;
    description: string;
    path: string;
    recvNum?: string;
    lineNum?: string;
    dealerAcnt?: string;
    appkey?: string;
    username?: string;
    passwd?: string;
    hbKey?: string;
    testing?: string;
    includeCustomerIp?: boolean;
    dateModified?: string;
    dateEntered?: string;
    disabled?: string[];
    status?: string;
}

interface AlulaReceiverData extends AlulaReceiver {}

export class AlulaReceiverHelper {
    static dbEndpoint = "receivers";
    static readonly importMap: ImportMap<AlulaReceiver, AlulaReceiverData> = [
        { i: "id", o: "id" },
        { i: "dealerId", o: "dealerId", skipExport: true },
        { i: "receiverType", o: "receiverType" },
        { i: "name", o: "name", skipExport: true },
        { i: "description", o: "description" },
        { i: "path", o: "path" },
        { i: "recvNum", o: "recvNum" },
        { i: "lineNum", o: "lineNum" },
        { i: "dealerAcnt", o: "dealerAcnt" },
        { i: "appkey", o: "appkey" },
        { i: "username", o: "username" },
        { i: "passwd", o: "passwd" },
        { i: "hbKey", o: "hbKey" },
        { i: "testing", o: "testing" },
        { i: "includeCustomerIp", o: "includeCustomerIp" },
        { i: "dateModified", o: "dateModified", skipExport: true },
        { i: "dateEntered", o: "dateEntered", skipExport: true },
        { i: "disabled", o: "disabled", skipExport: true },
        { i: "status", o: "status", skipExport: true },
    ];

    static fromDbObject(dbObject: AlulaResponseData): AlulaReceiver {
        const receiver = ClassImporterExporter.importObject(dbObject.attributes, this.importMap);
        receiver.id = dbObject.id;
        return receiver;
    }

    static toDbObject(receiver: AlulaReceiver): Partial<AlulaReceiverData> {
        return ClassImporterExporter.exportObject(receiver, this.importMap);
    }
}
